import type { SkinManifest } from '@/shared/theme/orange-sports-skin';

const skinRoot = '/skins/gc987-h5';

/** GC987 H5 皮肤：素材/样式自源站 https://gc987.com 抓取落地。 */
export const gc987H5Skin: SkinManifest = {
  assets: {
    avatar: `${skinRoot}/brand/icon.png`,
    chests: {
      claimable: `${skinRoot}/banners/bonus-100.png`,
      locked: `${skinRoot}/banners/bonus-50.png`,
      opened: `${skinRoot}/banners/bonus-100.png`,
    },
    hero: `${skinRoot}/banners/banner-1.png`,
    logo: `${skinRoot}/brand/logo.png`,
    pixQr: `${skinRoot}/brand/icon.png`,
  },
  brandName: 'GC987.com',
  campaigns: [
    {
      accent: 'blue',
      artworkOnly: true,
      cta: 'Ver agora',
      eyebrow: 'Promo',
      image: `${skinRoot}/banners/banner-1.png`,
      key: 'banner-1',
      reward: '',
      subtitle: '',
      title: 'Banner 1',
      to: '/promotions',
    },
    {
      accent: 'blue',
      artworkOnly: true,
      cta: 'Ver agora',
      eyebrow: 'Promo',
      image: `${skinRoot}/banners/banner-2.png`,
      key: 'banner-2',
      reward: '',
      subtitle: '',
      title: 'Banner 2',
      to: '/promotions',
    },
    {
      accent: 'gold',
      artworkOnly: true,
      cta: 'Ver VIP',
      eyebrow: 'VIP',
      image: `${skinRoot}/banners/vip.png`,
      key: 'vip',
      reward: '',
      subtitle: '',
      title: 'VIP',
      to: '/vip',
    },
    {
      accent: 'green',
      artworkOnly: true,
      cta: 'Convidar',
      eyebrow: 'Convite',
      image: `${skinRoot}/banners/banner-3.png`,
      key: 'banner-3',
      reward: '',
      subtitle: '',
      title: 'Convite',
      to: '/agent-share',
    },
    {
      accent: 'orange',
      artworkOnly: true,
      cta: 'Abrir',
      eyebrow: 'Bônus',
      image: `${skinRoot}/banners/bonus-50.png`,
      key: 'bonus-50',
      reward: '',
      subtitle: '',
      title: 'Bônus 50%',
      to: '/promotions',
    },
  ],
  categories: [
    {
      active: true,
      image: `${skinRoot}/icons/popular.svg`,
      label: 'Popular',
      subtitle: 'Hot',
      type: 'popular',
    },
    {
      image: `${skinRoot}/games/fortune-tiger.jpg`,
      label: 'Slot',
      subtitle: 'Slots',
      type: 'slot',
    },
    {
      image: `${skinRoot}/games/fortune-rabbit.jpg`,
      label: 'PG',
      subtitle: 'PG Soft',
      type: 'pg',
    },
    {
      image: `${skinRoot}/games/pinata-wins.jpg`,
      label: 'Cassino',
      subtitle: 'Live',
      type: 'live_casino',
    },
  ],
  code: 'gc987-h5',
  games: [
    {
      badge: 'POPULAR',
      image: `${skinRoot}/games/fortune-snake.jpg`,
      provider: 'PG',
      title: 'Fortune Snake',
      type: 'slot',
    },
    {
      image: `${skinRoot}/games/fortune-rabbit.jpg`,
      provider: 'PG',
      title: 'Fortune Rabbit',
      type: 'slot',
    },
    {
      image: `${skinRoot}/games/pinata-wins.jpg`,
      provider: 'PG',
      title: 'Pinata Wins',
      type: 'slot',
    },
    {
      image: `${skinRoot}/games/fortune-dragon.jpg`,
      provider: 'PG',
      title: 'Fortune Dragon',
      type: 'slot',
    },
    {
      image: `${skinRoot}/games/ganesha-gold.jpg`,
      provider: 'PG',
      title: 'Ganesha Gold',
      type: 'slot',
    },
    {
      image: `${skinRoot}/games/double-fortune.jpg`,
      provider: 'PG',
      title: 'Double Fortune',
      type: 'slot',
    },
    {
      image: `${skinRoot}/games/fortune-ox.jpg`,
      provider: 'PG',
      title: 'Fortune Ox',
      type: 'slot',
    },
    {
      image: `${skinRoot}/games/fortune-tiger.jpg`,
      provider: 'PG',
      title: 'Fortune Tiger',
      type: 'slot',
    },
  ],
};

export const gc987NavAssets = {
  deposit: `${skinRoot}/nav/deposit.svg`,
  /** 源站 first/svg/tabbar/deposit-blue-dark-on.png */
  depositOn: `${skinRoot}/nav/deposit-on.png`,
  /** 源站中间充值底座（notch 内装饰） */
  depositPedestal: `${skinRoot}/gc987.com/first/svg/tabbar/deposit-blue-dark.svg`,
  inicio: `${skinRoot}/nav/inicio.png`,
  menu: `${skinRoot}/icons/menu.svg`,
  perfil: `${skinRoot}/nav/perfil.png`,
  promo: `${skinRoot}/nav/promo.png`,
  search: `${skinRoot}/icons/search.svg`,
  tabbarBg: `${skinRoot}/nav/tabbar-bg.svg`,
  withdraw: `${skinRoot}/nav/withdraw.png`,
} as const;

export const gc987ThemeTokenUrl = `${skinRoot}/theme-tokens.json`;
